module.exports = __webpack_public_path__ + "img/logo.2377ba5e.png";